
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11.953","cy":"11.97","r":"11.46","fill":"#53a827"}}),_c('path',{attrs:{"d":"M6 13.223L8.45 16.7a1.05 1.05 0 001.707.051L18 6.828","fill":"none","stroke":"#fff","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M19.955 4.044c4.393 4.393 4.393 11.517 0 15.91-4.393 4.393-11.517 4.393-15.91 0-4.393-4.393-4.393-11.517 0-15.91 4.393-4.393 11.517-4.393 15.91 0","fill":"none","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    